import React, { useRef, useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { components, constants } from 'cng-web-lib'
import { A6TranslationContext } from './contexts/A6TranslationContext'
import Box from '@material-ui/core/Box'
import TaciOcnA6ContainerFormProperties from './TaciOcnA6ContainerFormProperties'

const {
    button: { CngPrimaryButton },
    form: { CngForm },
    CngDialog
} = components

const { FormState } = constants

function TaciOcnA6ContainerDialog(props) {
    const { open, onClose, container, showNotification } = props
    const { getValues, setValue, formState: { isSubmitting } } = useFormContext()
    const { getTranslatedText } = useContext(A6TranslationContext)

    const lastIndex = useRef(0)

    const { initialValues, makeValidationSchema } = TaciOcnA6ContainerFormProperties.formikProps

    function handleAddContainer(data) {
        const containers = [...getValues('taciOcnA6Container'), data].map(
            (container) => ({ ...container, _id: ++lastIndex.current })
        )

        setValue('taciOcnA6Container', containers)
        onClose()
    }

    function handleEditContainer(data) {
        const containers = [...getValues('taciOcnA6Container')]
        const index = containers.findIndex((container) =>
            container.id ? container.id === data.id : container._id === data._id
        )

        containers[index] = data

        setValue('taciOcnA6Container', containers)
        onClose()
    }

    return (
        <CngDialog
            dialogContent={
                <CngForm
                    fieldLevel='form'
                    formikProps={{
                        initialValues: container || initialValues,
                        makeValidationSchema: makeValidationSchema,
                        onSubmit: (data) => {
                            if (container) {
                                handleEditContainer(data)
                            } else {
                                handleAddContainer(data)
                            }
                        }
                    }}
                    formState={FormState.COMPLETED}
                    innerForm={true}
                    renderBodySection={(labelMap, shouldHideMap) => (
                        <TaciOcnA6ContainerFormProperties.Fields showNotification={showNotification} shouldHideMap={shouldHideMap} />
                    )}
                    renderButtonSection={() => (
                        <Box display='flex' justifyContent='flex-end'>
                            <CngPrimaryButton type='submit' disabled={isSubmitting}>
                                {container ? "Update" : "Save"}
                            </CngPrimaryButton>
                        </Box>
                    )}
                />
            }
            dialogTitle={getTranslatedText('A6', 'taciOcnA6Container')}
            fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
            fullWidth
            maxWidth='lg'
            onClose={onClose}
            open={open}
            shouldShowCloseButton
        />
    )
}

export default TaciOcnA6ContainerDialog
